import { render, staticRenderFns } from "./Collaborations.vue?vue&type=template&id=07c9e60e&scoped=true&"
import script from "./Collaborations.vue?vue&type=script&lang=js&"
export * from "./Collaborations.vue?vue&type=script&lang=js&"
import style0 from "./Collaborations.vue?vue&type=style&index=0&id=07c9e60e&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c9e60e",
  null
  
)

export default component.exports